<div class="switch-account-container">
  <div class="welcome-header" (click)="goBack()" *ngIf="selectedUser" style="cursor: pointer;">
    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M15 18L9 12L15 6" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    &nbsp; -->
    <h1>Welcome Back!</h1>
  </div>
  <div class="welcome-header" *ngIf="!selectedUser">
    <h1>Welcome Back</h1>
  </div>
  <div class="accounts-list" *ngIf="!selectedUser">
    <div class="account-card" 
          *ngFor="let user of savedUsers; let i = index; trackBy: trackByIndex"
          (click)="selectUser(user)" 
          >
      <div class="account-info">
        <img *ngIf="!showInitials(user)" [src]="user.profileImage" alt="" class="avatar" (error)="onImageError(user.email)">
        <div *ngIf="showInitials(user)" class="avatar-initials">{{ getInitials(user.name) }}</div>
        <div class="account-details">
          <span class="account-name">Log in as {{ user.name }}</span>
          <span class="account-email">{{ user.email }}</span>
        </div>
      </div>
      <img src="/assets/images/switch-account/Outline Icons.svg" alt="Select account" class="chevron-icon">
    </div>
    <div class="account-card" (click)="onUseAnotherAccount()">
      <div class="account-info">
        <div class="user-icon-container">
          <img src="/assets/images/switch-account/Frame 1171276019.svg" alt="User icon" class="user-icon">
        </div>
        <span class="account-name">Use another account</span>
      </div>
      <img src="/assets/images/switch-account/Outline Icons.svg" alt="Select account" class="chevron-icon">
    </div>
  </div>

  <div class="login-form-container" *ngIf="selectedUser">
    <div class="account-info selected-user-card">
      <img *ngIf="!showInitials(selectedUser) && !selectedUserImageFailed" [src]="selectedUser.profileImage" alt="" class="avatar" (error)="selectedUserImageFailed = true">
      <div *ngIf="showInitials(selectedUser) || selectedUserImageFailed" class="avatar-initials">{{ getInitials(selectedUser.name) }}</div>
      <div class="account-details">
        <span class="account-name"> Log in as {{ selectedUser.name }}</span>
        <span class="account-email">{{ selectedUser.email }}</span>
      </div>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="login()" class="login-form">
      <div class="form-field">
        <div class="password-input-container form-group">
          <label for="password" class="form-label">Password<span class="required">*</span></label>
          <input 
            [type]="showPassword ? 'text' : 'password'" 
            placeholder="Password"
            formControlName="password"
            [ngClass]="{'error': passwordError}"
          >
          <img 
            [src]="showPassword ? '/assets/images/eye.svg' : '/assets/images/eye-off.svg'" 
            alt="Toggle password visibility" 
            class="password-toggle-icon"
            (click)="togglePasswordVisibility()"
          >
        </div>
        <div class="error-message2"   *ngIf="passwordError"> {{passwordError}}</div>
        <div class="forgot-password-link">
          <a [routerLink]="['/forgot-password']" class="btn btn-tertiary btn-small">Forgot password?</a>
        </div>
      </div>

      <app-captcha *ngIf="showCaptcha"></app-captcha>

      <button type="submit" class="btn btn-primary btn-large" [ngClass]="{'disabled': loginForm.invalid || isSubmitting}" [disabled]="loginForm.invalid || isSubmitting">
        {{ isSubmitting ? 'Logging in...' : 'Log in' }}
      </button>
      <div class="forgot-login-link">
        <a (click)="onUseAnotherAccount()" style="cursor: pointer;text-decoration: underline;">Log in with another account</a>
      </div>
    </form>
    
  </div>

  <!-- <div class="remove-account-link">
    <a href="#">Remove account</a>
  </div> -->
  <div class="privacy-banner">
    <img src="/assets/images/switch-account/Icon-lock.png" alt="Privacy lock" class="lock-icon">
    <div class="privacy-text">
      <p class="privacy-title">Your privacy matters to us!</p>
      <p>We use industry-leading encryption and security measures to keep your information safe.</p>
    </div>
  </div>
</div>

